import { ListGroupItem, ListGroupItemProps } from 'reactstrap';

import { RemoveIndex, Spacer } from '../../../../types';

import './styles.css';

export type LayoutProps = RemoveIndex<ListGroupItemProps> & {
	name: JSX.Element;
	currentHours: JSX.Element;
	hoursWarning: JSX.Element;
	address: JSX.Element;
	distance: JSX.Element;
	p?: Spacer;
	px?: Spacer;
	py?: Spacer;
	pt?: Spacer;
	pr?: Spacer;
	pb?: Spacer;
	pl?: Spacer;
};

export const Layout: React.FC<LayoutProps> = ({
	name,
	currentHours,
	hoursWarning,
	address,
	distance,
	children,
	className,
	p = 3,
	px = p,
	py = p,
	pt = py,
	pr = px,
	pb = py,
	pl = px,
	...props
}) => (
	<ListGroupItem className={`store-list-item-layout p-0 m-0`} {...props}>
		{/* ms- layout */}
		{/* <div className="d-ms-none my-3">
			{[
				name,
				currentHours,
				hoursWarning,
				address,
				distance,
				<div>{children}</div>
			].map((ele, key, arr) =>
				key === arr.length - 1 ? (
					<Fragment key={key}>{ele}</Fragment>
				) : (
					<div className="mb-1" key={key}>
						{ele}
					</div>
				)
			)}
		</div> */}

		{/* ms+ layout */}
		<div className="d-ms-block">
			<div className="d-flex justify-content-between">
				{name}

				{distance}
			</div>

			<div className="d-flex justify-content-between align-items-center">
				{address}

				<div>{children}</div>
			</div>

			<div className="d-flex justify-content-between mb-2">
				{currentHours}

				{hoursWarning}
			</div>
		</div>
	</ListGroupItem>
);
